'use client';
import { ChevronDown, ChevronUp } from '@v2/ui/Icon/Arrow';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@v2/ui/Command/Command';
import { Popover, PopoverContent, PopoverTrigger } from '@v2/ui/Popover';
import clsx from 'clsx';
import { useState } from 'react';

export const OpponentsDropdownFilter = ({
  teams,
  selectedValue,
  onOpponentChange,
  onSearch,
  defaultLabel = 'All opponents',
  compactMobile = false,
  selectionLabel = 'Opponent',
  searchPlaceholder = 'Search opponents...',
  emptyLabel = 'No opponents found.',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const buttonTriggerClassname = clsx(
    'flex shrink-0 border border-gray-200 rounded-lg items-center gap-x-2',
    compactMobile
      ? 'h-11 w-full min-w-0 justify-between px-3 text-sm md:h-12 md:w-auto md:min-w-32 md:px-4 md:text-base'
      : 'h-9 min-w-32 px-4 md:h-12',
    {
      'bg-gray-800 text-white': !!selectedValue,
    }
  );

  const onChangeSearchInput = (value: string) => {
    setSearchValue(value);
    onSearch(value.trimStart());
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`${selectionLabel}: ${selectedValue?.team ?? defaultLabel}`}
          className={buttonTriggerClassname}
        >
          <span className={compactMobile ? 'min-w-0 truncate' : undefined}>
            {selectedValue?.team ?? defaultLabel}
          </span>
          {isOpen ? (
            <ChevronUp className="shrink-0" size="20" />
          ) : (
            <ChevronDown className="shrink-0" size="20" />
          )}
        </button>
      </PopoverTrigger>

      <PopoverContent
        className={compactMobile ? 'max-w-[calc(100vw-2rem)] p-0' : 'p-0'}
        align="start"
      >
        <Command className="rounded-lg">
          <CommandInput
            placeholder={searchPlaceholder}
            value={searchValue}
            onValueChange={onChangeSearchInput}
            onClose={() => setIsOpen(false)}
            autoFocus
          />
          <CommandList>
            <CommandEmpty>{emptyLabel}</CommandEmpty>
            <CommandGroup>
              {teams?.map((item) => (
                <CommandItem
                  key={item.teamId}
                  onSelect={() => {
                    onOpponentChange(item);
                    setIsOpen(false);
                  }}
                  className="cursor-pointer"
                >
                  {item.team}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
